
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venue",
      function () {
        return require("private-next-pages/venue.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venue"])
      });
    }
  